jQuery( document ).ready(function() {
    jQuery('#Slider-template--15322109837478__1642607527967bd1de').slick({
      dots: true,
      infinite: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            dots: true
          }
        },{
          breakpoint: 989,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }
      ]
    });
    jQuery('.blog .blog__posts').slick({
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: false,
      nextArrow: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }
      ]
    });
    jQuery('.our-brands-wrapper').slick({
      dots: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplay: true,
  			autoplaySpeed: 2000,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplay: true,
  			autoplaySpeed: 2000,
          }
        }
      ]
    });
    jQuery('.hero-section .hero-wrapper').slick({
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
    });
  
  $('.list-tabs .tab-title a').on('click',function(e){
    e.preventDefault();
    var tabid = $(this).attr('data-target');
    $(this).closest('.list-tabs').find('.tab-title a.active').removeClass('active');
    $('.wrapper-tab-content .tab-content.active').removeClass('active');
    $('.wrapper-tab-content .tab-content[id="'+tabid+'"]').addClass('active');
    $(this).addClass('active');
  });
  
  if($(window).width() <= 749){
    $('.tab-title a').on('click',function(){
      var title = $(this).attr('data-target');
      $(this).toggleClass("active");
      $('.tab-content[id="'+title+'"]').slideToggle();
    });
  }
  // Fade slides overlap, so native lazy loading fetches every gallery image.
  // Activate a slide's responsive sources only when it is selected.
  function loadGallerySlide(slick, index) {
    var slide = slick.$slides.get(index);
    if (!slide) return;
    slide.querySelectorAll('img[data-gallery-src]').forEach(function(image) {
      var srcset = image.getAttribute('data-gallery-srcset');
      if (srcset) image.setAttribute('srcset', srcset);
      image.setAttribute('src', image.getAttribute('data-gallery-src'));
      image.removeAttribute('data-gallery-srcset');
      image.removeAttribute('data-gallery-src');
    });
  }
  $('.product-main-image')
    .on('init', function(event, slick) { loadGallerySlide(slick, slick.currentSlide); })
    .on('beforeChange', function(event, slick, current, next) { loadGallerySlide(slick, next); })
    .slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: true,
    asNavFor: '.product-thumbnail-images'
  });
  $('.product-thumbnail-images').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product-main-image',
    dots: false,
    infinite: true,
    focusOnSelect: true,
    responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
  ]
  });
});
/* Sticky Add-to-Cart bar */
(function(){
  var bar = document.getElementById('tsStickyAtc');
  var mainBtn = document.querySelector('.product-form__submit');
  if(!bar || !mainBtn) return;
  var stickyBtn = document.getElementById('tsStickyBtn');
  if(stickyBtn){ stickyBtn.addEventListener('click', function(e){ e.preventDefault(); mainBtn.click(); }); }
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var above = en.boundingClientRect.top < 0;
        if(!en.isIntersecting && above){ bar.classList.add('is-visible'); }
        else { bar.classList.remove('is-visible'); }
      });
    }, { threshold: 0 });
    io.observe(mainBtn);
  }
})();

